

















import { Vue, Component, Prop } from "vue-property-decorator";
import Bridge from "@/common/bridge";

import getUrlParam from '@/common/utils/getUrlParam';

@Component
export default class CallPhone extends Vue {
  @Prop({ required: true }) phone!: string;

  handleClickPhone(): void {
    if (getUrlParam("type") !== "preview") {
      Bridge.callHandler((Api: any) => {
        Api.callContact({ number: this.phone });
      });
    }
  }
}
